import { createContext, useContext } from "react";

export type Language = "en" | "ne" | "hi";

export interface LanguageOption {
  code: Language;
  label: string;
  nativeLabel: string;
  flag: string;
}

export const languages: LanguageOption[] = [
  { code: "en", label: "EN", nativeLabel: "English", flag: "EN" },
  { code: "ne", label: "NE", nativeLabel: "नेपाली", flag: "NP" },
  { code: "hi", label: "HI", nativeLabel: "हिन्दी", flag: "IN" },
];

export interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => Promise<void>;
  t: (key: string, options?: any) => string;
  i18n: any;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined,
);

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
